export const hostImagePath = "http://www.xbrainnet.cn/"
// export const hostImagePath = "http://127.0.0.1:7001/" 
export const userKey = process.env.NODE_ENV === 'production' ? 'XCZN_ADMIN_USER_INFO' : 'XCZN_ADMIN_USER_INFO_TEST'


// WEBPACK FOOTER //
// ./src/config/index.js